<template>
  <div>
    <div class="player-container">
      <div id="twitch-player">twitch</div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';

export default {
  name: 'TwitchEmbed',
  data () {
    return {
      worker: null,
    }
  },
  created () {
    setTimeout(() => {
      this.createPlayer();
    }, 1000);
  },
  methods: {
    checkIfShouldEmbed() {

    },
    createPlayer() {
      // do nothing
    },
    createPlayer2() {
      const parents = process.env.NODE_ENV === 'development' ? ["localhost.likezoid.com", "client.likezoid.com"] : ["client.likezoid.com"];
      
      // Twitch options
      const options = {
        width: 300,
        height: 450,
        autoplay: true,
        channel: 'keeoh',
        parent: parents,
      };

      const embed = new window.Twitch.Embed("twitch-player", options);
      embed.addEventListener(window.Twitch.Embed.VIDEO_READY, () => {
        var player = embed.getPlayer();
        player.play();
        // Twitch.Player.ONLINE	
        setInterval(function() {
          if (player && player.getVolume() > 0.001) {
            player.setVolume(0.001);
          }
        }, 1000);
      });
     /*
      */
    }
  }
}
</script>

<style>
.player-container {
  z-index:99999999;
  position: absolute;
  top: 0px;
  left: -2000px;
  width: 500px;
  height: 500px;
  border: 1px solid red;
  opacity: 0.1;
}
</style>